/** Toggleable customer-portal sections (dashboard + profile are always on). */
export const CUSTOMER_PORTAL_SECTION_KEYS = [
  'products',
  'cart',
  'orders',
  'downloads',
  'tickets',
  'coupons',
  'membership',
  'subscriptions',
  'schedule',
] as const;

export type CustomerPortalSectionKey = (typeof CUSTOMER_PORTAL_SECTION_KEYS)[number];

export type CustomerPortalSettings = Record<CustomerPortalSectionKey, boolean>;

export const DEFAULT_CUSTOMER_PORTAL_SETTINGS: CustomerPortalSettings = {
  products: true,
  cart: true,
  orders: true,
  downloads: true,
  tickets: true,
  coupons: true,
  membership: true,
  subscriptions: true,
  schedule: true,
};

/** Map customer portal path prefixes to toggleable section keys. */
export const CUSTOMER_PORTAL_HREF_SECTION: Record<string, CustomerPortalSectionKey> = {
  '/customer/products': 'products',
  '/customer/cart': 'cart',
  '/customer/orders': 'orders',
  '/customer/downloads': 'downloads',
  '/customer/tickets': 'tickets',
  '/customer/coupons': 'coupons',
  '/customer/membership': 'membership',
  '/customer/subscriptions': 'subscriptions',
  '/customer/schedule': 'schedule',
};

export function parseCustomerPortalSettings(raw: unknown): CustomerPortalSettings {
  const obj = raw && typeof raw === 'object' && !Array.isArray(raw) ? (raw as Record<string, unknown>) : {};
  const result = { ...DEFAULT_CUSTOMER_PORTAL_SETTINGS };
  for (const key of CUSTOMER_PORTAL_SECTION_KEYS) {
    if (obj[key] === false) result[key] = false;
    else if (obj[key] === true) result[key] = true;
  }
  return result;
}

export function isCustomerPortalSectionEnabled(
  settings: CustomerPortalSettings | null | undefined,
  section: CustomerPortalSectionKey,
): boolean {
  if (!settings) return true;
  return settings[section] !== false;
}

export function isCustomerPortalHrefEnabled(
  settings: CustomerPortalSettings | null | undefined,
  href: string,
): boolean {
  const section = CUSTOMER_PORTAL_HREF_SECTION[href];
  if (!section) return true;
  return isCustomerPortalSectionEnabled(settings, section);
}
